@if ((isMobileLayoutEnabled$ | async) === true) {
  @if (dialogOpen$ | async) {
    <div class="mobile-feature-info-dialog">
      <div class="layer-list-dropdown-wrapper">
        <tm-feature-info-layer-dropdown></tm-feature-info-layer-dropdown>
      </div>
      <tm-feature-info-content class="feature-info-content--mobile"
                               [selectedLayer]="selectedLayer$ | async"
                               [currentFeature]="currentFeature()"
                               [isPrevButtonDisabled]="(isPrevButtonDisabled$ | async) ?? false"
                               [isNextButtonDisabled]="(isNextButtonDisabled$ | async) ?? false"
                               [isEditPossible]="isEditPossible() ?? false"
                               [hideEmptyValues]="config()?.hideEmptyValues ?? false"
                               (showNextFeatureInfoFeature)="next()"
                               (showPreviousFeatureInfoFeature)="back()"
                               (editFeature)="editFeature()">
      </tm-feature-info-content>
    </div>
  }
} @else {
  <tm-dialog [open]="dialogOpen$ | async"
             [openFromRight]="true"
             [widthMargin]="panelWidthMargin"
             [width]="expandedList() ? panelWidth : panelWidthCollapsed"
             class="feature-info-dialog"
             (closeDialog)="closeDialog()"
             [allowCollapse]="true"
             [collapsed]="dialogCollapsed$ | async"
             (expandCollapseDialog)="expandCollapseDialog()"
             dialogTitle="Object Information"
             i18n-dialogTitle="@@core.feature-info.object-information">
    @if (expandedList()) {
      <div class="layer-list-wrapper">
        <div class="toggle">
          <button mat-icon-button tmTooltip="Collapse layer list" i18n-tmTooltip="@@core.feature-info.collapse-layer-list" (click)="toggleListExpanded()">
            <mat-icon svgIcon="chevron_right"></mat-icon>
          </button>
        </div>
        <div class="layer-list">
          <tm-feature-info-layer-list></tm-feature-info-layer-list>
        </div>
      </div>
    }
    <div class="feature-list">
      @if (selectedSingleLayer$ | async; as layer) {
        @if (layer.totalCount !== 0) {
          <tm-feature-info-layer-item [layer]="getLayerListItem(layer)"></tm-feature-info-layer-item>
        } @else if (!expandedList()) {
          <div class="no-result-message" i18n="@@core.feature-info.no-features-found">No features found</div>
        }
      } @else if(!expandedList()) {
        <div class="layer-list-dropdown-wrapper">
          @if (isWideScreen()) {
            <button mat-icon-button tmTooltip="Expand layer list" i18n-tmTooltip="@@core.feature-info.expand-layer-list" (click)="toggleListExpanded()">
              <mat-icon svgIcon="chevron_left"></mat-icon>
            </button>
          }
          <tm-feature-info-layer-dropdown></tm-feature-info-layer-dropdown>
        </div>
      }
      <tm-feature-info-content
        [selectedLayer]="selectedLayer$ | async"
        [currentFeature]="currentFeature()"
        [isPrevButtonDisabled]="(isPrevButtonDisabled$ | async) ?? false"
        [isNextButtonDisabled]="(isNextButtonDisabled$ | async) ?? false"
        [isEditPossible]="isEditPossible() ?? false"
        [hideEmptyValues]="config()?.hideEmptyValues ?? false"
        (showNextFeatureInfoFeature)="next()"
        (showPreviousFeatureInfoFeature)="back()"
        (editFeature)="editFeature()">
      </tm-feature-info-content>
    </div>
  </tm-dialog>
}

